import { NSARouterMakerResult } from "namirasoft-account-react";
import { IBaseComponentProps, NSBox, NSBoxString, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { InferenceRouterProps } from "../InferenceRouterProps";

export interface ChatTagValue
{
    name: string;
    value: string;
}

export interface ChatTagLineProps extends IBaseComponentProps, NSARouterMakerResult, InferenceRouterProps
{
    index: number;
    deletable: boolean;
    onDelete: () => void;
    onChanged?: (value: ChatTagValue | null) => void;
}

export default class ChatTagLine extends Component<ChatTagLineProps>
{
    static IS_DIRTY(value: ChatTagValue | null): boolean
    {
        if (value && value.name)
            return true;
        return false;
    }

    private NSBoxString_Name = createRef<NSBoxString>();
    private NSBoxString_Value = createRef<NSBoxString>();

    constructor(props: ChatTagLineProps)
    {
        super(props);
        this.getValue = this.getValue.bind(this);
        this.isDirty = this.isDirty.bind(this);
        this.onChanged = this.onChanged.bind(this);
    }

    getValue(checkError: boolean = false): ChatTagValue | null
    {
        let name = this.NSBoxString_Name.current?.getValue(checkError) ?? "";
        let value = this.NSBoxString_Value.current?.getValue(checkError) ?? "";
        if (!name)
            return null;
        return { name, value };
    }

    setValue(value: ChatTagValue)
    {
        this.NSBoxString_Name.current?.setValue(value.name);
        this.NSBoxString_Value.current?.setValue(value.value);
    }

    isDirty(): boolean
    {
        return ChatTagLine.IS_DIRTY(this.getValue(false));
    }

    private onChanged()
    {
        if (this.props.onChanged)
            this.props.onChanged(this.getValue(false));
    }

    override render()
    {
        return (
            <NSRow style={{ ...this.props.style }}>
                <NSBoxString
                    ref={this.NSBoxString_Name}
                    {...this.props}
                    title={`Tag Name ${this.props.index + 1}`}
                    required
                    style={{ width: "100%", maxWidth: NSBox.width.one }}
                    onChanged={this.onChanged}
                />
                <NSBoxString
                    ref={this.NSBoxString_Value}
                    {...this.props}
                    title={`Tag Value ${this.props.index + 1}`}
                    required
                    style={{ width: "100%", maxWidth: NSBox.width.one }}
                    onChanged={this.onChanged}
                    menu={{
                        builtin: { delete: { enabled: this.props.deletable, onDelete: () => { this.props.onDelete(); } } },
                        items: []
                    }}
                />
            </NSRow>
        );
    }
}